<template>
  <div>
    <ChargesSettingsComponent />
  </div>
</template>

<script>
import ChargesSettingsComponent from "./ChargesSettingsComponent";
export default {
  name: "ChargesSettings",
  components: {
    ChargesSettingsComponent
  }
};
</script>

<style scoped></style>
